// Module
var code = "<mm-error ng-model=\"$ctrl.site\"></mm-error> <ir-loading-overlay is-loading=\"$ctrl.site.isLoading\"></ir-loading-overlay> <div ng-hide=\"$ctrl.site.isLoading\"> <div ng-if-start=\"$ctrl.site.isSuccessful\"></div> <div ng-if-end> <mm-projection-map site=\"$ctrl.site.data\"> </mm-projection-map> </div> </div> ";
// Exports
var _module_exports = code;;
var path = '/App/Components/Site/DesignAndPlanning/DesignAndPlanning.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;